import { request } from "./http";
import type { BlogPost, BlogBlock } from "../types";

export const listBlogPosts = () => request<BlogPost[]>("/api/blog/posts");

export const getBlogPost = (slug: string) => request<BlogPost>(`/api/blog/posts/${slug}`);

export const createBlogPost = (body: {
  title: string;
  subtitle?: string | null;
  blocks: BlogBlock[];
  meta_title?: string | null;
  meta_description?: string | null;
  meta_site_name?: string | null;
  meta_image?: string | null;
  meta_image_width?: number | null;
  meta_image_height?: number | null;
  meta_image_type?: string | null;
}) => request<BlogPost>("/api/blog/posts", { method: "POST", body: JSON.stringify(body) });

export const updateBlogPost = (
  slug: string,
  body: {
    title: string;
    subtitle?: string | null;
    blocks: BlogBlock[];
    meta_title?: string | null;
    meta_description?: string | null;
    meta_site_name?: string | null;
    meta_image?: string | null;
    meta_image_width?: number | null;
    meta_image_height?: number | null;
    meta_image_type?: string | null;
  }
) =>
  request<BlogPost>(`/api/blog/posts/${slug}`, {
    method: "PUT",
    body: JSON.stringify(body),
  });
